import React, { FormEvent, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LockIcon, MailIcon, UserIcon } from "lucide-react";
import { AuthCard } from "../../components/auth/AuthCard";
import { SocialButtons } from "../../components/auth/SocialButtons";
import { PasswordStrength, passwordScore } from "../../components/auth/PasswordStrength";
import { TextField } from "../../components/ui/TextField";
import { BrutalButton } from "../../components/ui/BrutalButton";

/** Account only — languages, level and goals are handled by the onboarding flow right after. */
export function SignUp() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: ""
  });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(false);
  const submit = (e: FormEvent) => {
    e.preventDefault();
    const next: Record<string, string> = {};
    if (!form.name.trim()) next.name = "What should we call you?";
    if (!/^\S+@\S+\.\S+$/.test(form.email)) next.email = "Enter a valid email address.";
    if (passwordScore(form.password) < 2) next.password = "Make it a little stronger.";
    setErrors(next);
    if (Object.keys(next).length) return;
    setLoading(true);
    window.setTimeout(() => navigate("/app/onboarding", {
      state: {
        name: form.name.trim()
      }
    }), 700);
  };
  return <AuthCard title="Create your account" description="Free forever to start. No card needed." footer={<>
          Already learning?{" "}
          <Link to="/auth/signin" className="font-semibold text-ink underline underline-offset-4" data-id="element-1716" data-mp="26avmkx5wudiw">
            Sign in
          </Link>
        </>} data-id="element-1715" data-mp="2bbjfjodp94fr">
      <SocialButtons to="/app/onboarding" data-id="element-1717" data-mp="1xb8k081g31o9" />
      <form onSubmit={submit} noValidate className="space-y-4" data-id="element-1718" data-mp="1xecu1m1lcrmu">
        <TextField label="Name" icon={UserIcon} value={form.name} onValueChange={v => setForm({
        ...form,
        name: v
      })} error={errors.name} autoComplete="name" data-id="element-1719" data-mp="qxj16srr93lg" />
        <TextField label="Email" type="email" icon={MailIcon} value={form.email} onValueChange={v => setForm({
        ...form,
        email: v
      })} error={errors.email} autoComplete="email" data-id="element-1720" data-mp="ndily5i7b4sh" />
        <div data-id="element-1721" data-mp="edcccupmioyl">
          <TextField label="Password" type="password" icon={LockIcon} value={form.password} onValueChange={v => setForm({
          ...form,
          password: v
        })} error={errors.password} autoComplete="new-password" data-id="element-1722" data-mp="edlz89fdgg02" />
          {!errors.password && <PasswordStrength password={form.password} data-id="element-1723" data-mp="9eiz93e90zyy" />}
        </div>
        <BrutalButton type="submit" full size="lg" loading={loading} data-id="element-1724" data-mp="3quqx66ifb6e8">
          {loading ? "Creating account…" : "Create account"}
        </BrutalButton>
        <p className="text-center text-xs text-ink-2" data-id="element-1725" data-mp="3vudcclhtawpo">
          By continuing you agree to our{" "}
          <Link to="/terms" className="underline underline-offset-2" data-id="element-1726" data-mp="3hukpx2dbj2ni">Terms</Link> and{" "}
          <Link to="/privacy" className="underline underline-offset-2" data-id="element-1727" data-mp="3mrueygwspcat">Privacy Policy</Link>.
        </p>
      </form>
    </AuthCard>;
}